import numeral from "numeral";

export const formatCOPNumberInput = (number, commas = false) => {
    try {
        if (!number) {
            return ''
        }
        const valorNumerico = number.toString().replace(/[^\d]/g, "");
        const valorFormateado = valorNumerico.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return `$${valorFormateado}`;

    }
    catch (error) {
        console.log('error formatCOPNumber ', error);
        return "";
    }
}
export const formatCOPNumber = (numero, mostrarCentavos = false) => {
    // Asegurarse de que el número sea un valor numérico
    if (isNaN(numero)) {
        return "No es un número válido";
    }

    // Redondear el número a 2 decimales si se muestran centavos
    if (mostrarCentavos) {
        numero = Number(numero).toFixed(2);
    }

    // Convertir el número a una cadena
    const numeroStr = numero.toString();

    // Usar una expresión regular para agregar comas como separadores de miles
    const regex = /(\d)(?=(\d{3})+(?!\d))/g;
    const numeroFormateado = numeroStr.replace(regex, "$1,");

    // Agregar el símbolo de peso colombiano y, si es necesario, los centavos
    // const simbolo = mostrarCentavos ? " COP" : " COP";
    const simbolo = '$ ';
    return simbolo + numeroFormateado;
}

export const swapArrayElements = function (arr, indexA, indexB) {
    let temp = arr[indexA];
    arr[indexA] = arr[indexB];
    arr[indexB] = temp;
};

export const isAPhone = (str) => {
    if (typeof str !== "string") {
        return false;
    }

    const numero = Number(str);

    if (isNaN(numero) || !Number.isInteger(numero)) {
        return false;
    }

    if (str.length < 5) {
        return false;
    }


    return true;
}

export const millisecondsToMinutesAndSeconds = async (millis) => {
    let minutes = Math.floor(millis / 60000);
    let seconds = ((millis % 60000) / 1000).toFixed(0);
    return { minutes, seconds }
    //return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
}
export const FormatCreditCard = (value) => {
    // Eliminar cualquier carácter no numérico
    value = value.replace(/\D/g, '');

    const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    const matches = v.match(/\d{4,16}/g);
    const match = (matches && matches[0]) || '';
    const parts = [];
    for (let i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4));
    }
    if (parts.length > 0) {
        return parts.join(' ');
    } else {
        return value;
    }
}
export const FormatExpirationDate = (numberString, old_expiration_date_value) => {
    try {
        if (!numberString) {
            return ""
        }
        return numberString.replace(
            /[^0-9]/g, '' // To allow only numbers
        ).replace(
            /^([2-9])$/g, '0$1' // To handle 3 > 03
        ).replace(
            /^(1{1})([3-9]{1})$/g, '0$1/$2' // 13 > 01/3
        ).replace(
            /^0{1,}/g, '0' // To handle 00 > 0
        ).replace(
            /^([0-1]{1}[0-9]{1})([0-9]{1,2}).*/g, '$1/$2' // To handle 113 > 11/3
        );

    } catch (error) {
        console.log("error on expiration date formating");
        console.log(error);
        return numberString;
    }
}
export const copyClipbord = (text, onSuccess, onError) => {
   return navigator.clipboard.writeText(text)
        .then(() => {
            if (typeof onSuccess === "function") {
                onSuccess();
            }
        })
        .catch(err => {
            console.error("Error al copiar:", err);
            if (typeof onError === "function") {
                onError(err);
            }
        });
}

export const getNavInfo = () => {
    let nAgt = navigator.userAgent;
    let browserName = navigator.appName;
    let fullVersion = '' + parseFloat(navigator.appVersion);
    let majorVersion = parseInt(navigator.appVersion, 10);
    let nameOffset, verOffset, ix;
    if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset + 5);
    }
    else if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 6);
    }
    else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
    }
    else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
    }
    else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
    }
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
            browserName = navigator.appName;
        }
    }
    if ((ix = fullVersion.indexOf(";")) != -1) fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(" ")) != -1) fullVersion = fullVersion.substring(0, ix);
    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
        fullVersion = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
    }

    return { browserName }
}

export const getDeviceInfo = () => {
    const nav = window.navigator;
    const userAgent = nav.userAgent || '';
    const screenInfo = window.screen || {};

    const browserMatchers = [
        { name: 'Instagram', regex: /Instagram[ /]([\d.]+)/ },
        { name: 'Facebook', regex: /FBAV\/([\d.]+)/ },
        { name: 'Samsung Internet', regex: /SamsungBrowser\/([\d.]+)/ },
        { name: 'Android WebView', regex: /; wv\).*?Chrome\/([\d.]+)/ },
        { name: 'Edge', regex: /Edg(?:A|iOS)?\/([\d.]+)/ },
        { name: 'Opera', regex: /(?:OPR|Opera)\/([\d.]+)/ },
        { name: 'Chrome', regex: /(?:Chrome|CriOS)\/([\d.]+)/ },
        { name: 'Firefox', regex: /(?:Firefox|FxiOS)\/([\d.]+)/ },
        { name: 'Safari', regex: /Version\/([\d.]+).*Safari/ }
    ];
    const browser = browserMatchers.find(({ regex }) => regex.test(userAgent));
    const browserMatch = browser?.regex.exec(userAgent);
    const isIPadOS = /Macintosh/i.test(userAgent) && (nav.maxTouchPoints || 0) > 1;

    const operatingSystems = [
        { name: 'Windows', regex: /Windows NT/ },
        { name: 'Android', regex: /Android/ },
        { name: 'iOS', regex: /iPhone|iPad|iPod/ },
        { name: 'macOS', regex: /Mac OS X|Macintosh/ },
        { name: 'Linux', regex: /Linux/ }
    ];
    const operatingSystem = operatingSystems.find(({ regex }) => regex.test(userAgent));
    const isTablet = isIPadOS || /iPad|Tablet|PlayBook|Silk/i.test(userAgent) ||
        (/Android/i.test(userAgent) && !/Mobile/i.test(userAgent));
    const isMobile = nav.userAgentData?.mobile || /Mobi|Android|iPhone|iPod/i.test(userAgent);
    const connection = nav.connection || nav.mozConnection || nav.webkitConnection;

    return {
        browser: browser?.name || 'Unknown',
        browser_version: browserMatch?.[1] || null,
        operating_system: isIPadOS ? 'iOS' : operatingSystem?.name || 'Unknown',
        device_type: isTablet ? 'TABLET' : isMobile ? 'MOBILE' : 'DESKTOP',
        user_agent: userAgent || null,
        language: nav.language || null,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
        screen_resolution: screenInfo.width && screenInfo.height
            ? `${screenInfo.width}x${screenInfo.height}`
            : null,
        viewport: window.innerWidth && window.innerHeight
            ? `${window.innerWidth}x${window.innerHeight}`
            : null,
        pixel_ratio: window.devicePixelRatio || 1,
        touch_enabled: (nav.maxTouchPoints || 0) > 0,
        cookies_enabled: nav.cookieEnabled,
        online: nav.onLine,
        connection_type: connection?.effectiveType || null
    };
}

export const getPaymentDeviceNote = () => {
    const device = getDeviceInfo();
    const sanitize = (value, maxLength) => String(value ?? 'unknown')
        .replace(/[|=\r\n]/g, ' ')
        .slice(0, maxLength);
    const fields = [
        ['browser', device.browser, 30],
        ['version', device.browser_version, 30],
        ['os', device.operating_system, 20],
        ['device', device.device_type, 10],
        ['language', device.language, 20],
        ['timezone', device.timezone, 50],
        ['screen', device.screen_resolution, 20],
        ['viewport', device.viewport, 20],
        ['pixel_ratio', device.pixel_ratio, 10],
        ['touch', device.touch_enabled, 5],
        ['connection', device.connection_type, 10],
        ['ua', device.user_agent, 180]
    ];

    return fields
        .map(([key, value, maxLength]) => `${key}=${sanitize(value, maxLength)}`)
        .join('|')
        .slice(0, 500);
};
export const getParams = (url) => {
    new Proxy(new URLSearchParams(url), {
        get: (searchParams, prop) => searchParams.get(prop),
    })
};

export const formatPhoneNumber = (text) => {
    // let t = text.replace(/\D/g,""); //quitamos los caracteres que no sean digitos

    // t = t.substring(0, 11);// el maximo de digitos para el numero de telefono es 12
    // t = t.replace(/^(\d{3})/g, "("+t.substring(0,3)+")" ); //agregamos los parentesis. 
    // t = t.replace(/\)(\d{3})/g, ") "+t.substring(5,8)+"-" ); //agregamos un espacio y el primer guion

    let t = text.replace(/^(\d{3})(\d{3})(\d{}).*/, '($1) $2-$3'); //quitamos los caracteres que no sean digitos
    //console.log('number,', t)
    t = t.substring(0, 16);// el maximo de digitos para el numero de telefono es 12
    //t = t.substring(0, 14);// el maximo de digitos para el numero de telefono es 12
    t = t.replace(/^(\d{3})/g, "(" + t.substring(0, 3) + ")"); //agregamos los parentesis. 
    t = t.replace(/\)(\d{3})/g, ") " + t.substring(5, 8) + "-"); //agregamos un espacio y el primer guion

    return t
}
export const formatDocument = (num) => {
    try {
        var num = num.replace(/\./g, '');
        if (!isNaN(num)) {
            num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
            num = num.split('').reverse().join('').replace(/^[\.]/, '');
            return num;
        }

        else {
            return "";
        }
    }
    catch (error) {
        return "";
    }
}

export const getDigitsRegister = (text, isDataNumeric = false) => {
    return isDataNumeric ? parseInt(text.toString().replace(/\D/g, "")) : text.toString().replace(/\D/g, "");
}

export function capitalizeSentence(sentence) {

    return sentence
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
}

export const validateName = (cadena = '', isInt = false) => {
    try {

        const palabras = cadena?.split(' ');
        // Comprobar si hay mas de dos palabras
        if (palabras.length < 2) {
            if (isInt) {
                return true
            }
            return false;
        }
        // Comprobar si las palabras tienen al menos un carácter cada una
        if (palabras[0].length < 1 || palabras[1].length < 1) {
            return false;
        }

        return true;
    } catch (error) {
        console.log('Error validateName');
        return false
    }
}

export const getDigits = (text) => {
    return text.toString().replace(/\D/g, "");
}

export const formatMoneySplit = (amount, divide = ',') => {
    if (!amount) {
        return ''
    }
    return {
        part1: amount.toString().split(divide)[0],
        part2: amount.toString().split(divide)[1] || '',
    }

}

export const regexBrand = (url) => {
    const regex = /([A-Za-z]+)-(\d+)/;
    const match = url.match(regex);

    if (match) {
        const name = match[1];
        const phone = match[2];
        return { name, phone };
    }

    return null; // Retorna null si no hay coincidencias

}

export const isCobruURL = (value) => {
    return typeof value === "string" && /^[a-z0-9]{8}$/.test(value);
}

export const isBitppi72342403Profile = (profile) => {
    const brand = profile?.brand ? String(profile.brand).toUpperCase() : '';
    return ['BITPPI', 'BITTPI'].includes(brand) &&
        String(profile?.owner_document || '') === '72342403';
}

export const isBitppiAxiUser = (value, brand) => {
    return String(brand || '').toUpperCase() === 'BITPPI' &&
        /^axi$/i.test(String(value || '').trim());
}

export const getFranchise = (numeroTarjeta) => {
    const numero = numeroTarjeta.toString();
    const binPrefix = numero.toString().slice(0, 6); // Obtiene los primeros 6 dígitos

    if (/^4/.test(binPrefix)) {
        return "Visa";
    } else if (/^5[1-5]/.test(binPrefix)) {
        return "Mastercard";
    } else if (/^3[47]/.test(binPrefix)) {
        return "American Express";
    } else if (/^6(?:011|5)/.test(binPrefix)) {
        return "Discover";
    } else if (/^3(?:0[0-5]|[68])/.test(binPrefix)) {
        return "Diners Club";
    } else if (/^35/.test(binPrefix)) {
        return "JCB";
    } else {
        return "Franquicia desconocida";
    }
    /* if (/^4[0-9]{12}(?:[0-9]{3})?$/.test(numero)) {
      return "Visa";
    } else if (/^5[1-5][0-9]{14}$/.test(numero)) {
      return "Mastercard";
    } else if (/^3[47][0-9]{13}$/.test(numero)) {
      return "American Express";
    } else if (/^6(?:011|5[0-9]{2})[0-9]{12}$/.test(numero)) {
      return "Discover";
    } else if (/^3(?:0[0-5]|[68][0-9])[0-9]{11}$/.test(numero)) {
      return "Diners Club";
    } else if (/^35[0-9]{14}$/.test(numero)) {
      return "JCB";
    } else {
      return "Franquicia desconocida";
    } */
}
export const encodeEmail = (email) => {
    return email
        .split("")
        .map((char) => `&#${char.charCodeAt(0)};`)
        .join("");
};

export const hasUnderscore = (variableName) => /_/.test(variableName);

export const isEmail = (str) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(str);
};
